$(document).ready(function () {

$('.main-banner').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: $('.main-banner_dots'),
    arrows: false
});

$('.services-content').slick({
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: $('.services-btn_right'),
    prevArrow: $('.services-btn_left'),
    arrows: true,
    adaptiveHeight: false,
    infinite: true,
    margin: 12.5,
    responsive: [
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1060,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ]
});


    let orderProduct = function () {
      let selectHeader = document.querySelector('.order-product_header');
      let selectItem = document.querySelectorAll('.order-product_body_item');
      selectHeader.addEventListener("click", function () {
        selectToggle();
      });
      selectItem.forEach(function (item) {
        item.addEventListener("click", function () {
          selectChoose(item);
        });
      });
      function selectToggle() {
        document.querySelector('.order-product').classList.toggle('active');
      }
      function selectChoose(option) {
        let selectedText = $(option).text();
        $('.select__current').text(selectedText);
        $('.select__current').css('color', '#282828')
        selectToggle();
      }
    };

    orderProduct();


  
    $('.fancybox').fancybox({
    })
    
      
    let agrees = $('input[type="checkbox"]')
    agrees.click(function(){
        agrees.each(function(){
            if ($(this).is(':checked')){
                let btn = $(this).next('.btn')
                btn.removeAttr('disabled');
                let lbl = $(this).next('label')
                lbl.addClass('checked')
            } else {
                let btn = $(this).next('.btn')
                btn.attr('disabled', 'disabled'); 
                let lbl = $(this).next('label')
                lbl.removeClass('checked')
            }
        })
    });


    var wrapperMenu = document.querySelector('.wrapper-menu');

      wrapperMenu.addEventListener('click', function(){
        $('.header-mob-menu').addClass('active')
        $('.page').addClass('overflow')
      })

    var closeMenu = document.querySelector('.header-mob-menu_close');

        closeMenu.addEventListener('click', function(){
          $('.header-mob-menu').removeClass('active')
          $('.page').removeClass('overflow')
      })

      $('.catalog-doors-content_sort_body').click(function () {
        $('.catalog-doors-content_sort_body').toggleClass('active');
    });

    let filterItems = $('.catalog-doors-content_sort_body_item') 
    filterItems.click(function (event) {
        if ($(".catalog-doors-content_sort_body").hasClass("active")) {
          filterItems.each(function() {
            filterItems.removeClass('active')
            $(this).addClass('active')
          })
        }
    });


    $('.card-content_img_bottom').hover(function() {
      $('.card-content_img_top').toggleClass('card-top-transform')
    }) 

    var sliders = $('.sliders');
    
    sliders.each(function (i, el) {
    var leftArr = ('.arrow-left' + i)
    var rightArr = ('.arrow-right' + i)
    $(el).slick({
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $(leftArr),
        nextArrow: $(rightArr),
        responsive: [
          {
            breakpoint: 1160,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ]
    })
  })
});